// extracted by mini-css-extract-plugin
export default {"mapPolygonsPopupContainer":"MapPolygonsPopup_mapPolygonsPopupContainer__JuIsg","mapPolygonsPopup":"MapPolygonsPopup_mapPolygonsPopup__xUkzz"};